document.addEventListener('DOMContentLoaded', function () {
  class ProductDescriptionToggle extends HTMLElement {
    constructor() {
      super();

      this.headerElement = null;
      this.contentElement = null;
      this.moreButtonElement = null;
      this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');

      this.handleHeaderClick = this.handleHeaderClick.bind(this);
      this.handleMoreClick = this.handleMoreClick.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.headerElement = this.querySelector('[data-description-header]');
      this.contentElement = this.querySelector('[data-description-content]');
      this.moreButtonElement = this.querySelector('[data-description-more]');

      this.headerElement.addEventListener('click', this.handleHeaderClick);
      this.moreButtonElement.addEventListener('click', this.handleMoreClick);
      this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);

      this.syncToBreakpoint();
    }

    disconnectedCallback() {
      this.headerElement.removeEventListener('click', this.handleHeaderClick);
      this.moreButtonElement.removeEventListener('click', this.handleMoreClick);
      this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
    }

    get isMobile() {
      return this.mobileMediaQuery.matches;
    }

    get collapsedHeight() {
      const rawHeight = getComputedStyle(this).getPropertyValue('--description-collapsed-height');
      return parseInt(rawHeight, 10) || 360;
    }

    syncToBreakpoint() {
      if (this.isMobile) {
        this.classList.remove('product-description--collapsible', 'product-description--expanded');
        this.closeAccordion();
      } else {
        this.classList.remove('product-description--open');
        this.headerElement.setAttribute('aria-expanded', 'true');
        this.updateClamp();
      }
    }

    updateClamp() {
      const hasOverflow = this.contentElement.scrollHeight > this.collapsedHeight;
      this.classList.toggle('product-description--collapsible', hasOverflow);

      if (!hasOverflow) this.collapseContent();
    }

    closeAccordion() {
      this.classList.remove('product-description--open');
      this.headerElement.setAttribute('aria-expanded', 'false');
    }

    handleBreakpointChange() {
      this.syncToBreakpoint();
    }

    handleHeaderClick() {
      if (!this.isMobile) return;

      const isOpen = this.classList.toggle('product-description--open');
      this.headerElement.setAttribute('aria-expanded', isOpen);
    }

    handleMoreClick() {
      const isExpanded = this.classList.toggle('product-description--expanded');
      this.moreButtonElement.setAttribute('aria-expanded', isExpanded);
      this.moreButtonElement.textContent = isExpanded
        ? this.moreButtonElement.dataset.lessText
        : this.moreButtonElement.dataset.moreText;
    }

    collapseContent() {
      this.classList.remove('product-description--expanded');
      this.moreButtonElement.setAttribute('aria-expanded', 'false');
      this.moreButtonElement.textContent = this.moreButtonElement.dataset.moreText;
    }
  }
  if (!customElements.get('product-description-toggle')) {
    customElements.define('product-description-toggle', ProductDescriptionToggle);
  }
});
